import { apiHelper } from '@/utils/api.helper'

export const PAYMENT = {
  makePayment,
  makeStripePayment,
  paymentSeccess,
  downloadTest
}
const URL = {
  PAYMENT: 'payment',
  MAKE_PAYMENT: 'makePayment',
  STRIPE: 'stripe',
  PAYMENT_INTENT: 'paymentIntent'
}

function makePayment(po_number, method) {
  const requestHeader = {
    'po-number': `[${po_number}]`
  }
  return apiHelper(true, requestHeader).get(`${URL.PAYMENT}/${URL.MAKE_PAYMENT}`, { params: { payment_method: method } })
}

function makeStripePayment(po_number, method) {
  let requestBody = {
    currency: 'SGD',
    po_number: po_number,
    payment_method: method
  }
  return apiHelper().post(`${URL.PAYMENT}/${URL.STRIPE}/${URL.PAYMENT_INTENT}`, requestBody)
}

function paymentSeccess(value) {
  let requestBody = {
    payment_intent_id: value.payment_intent_id,
    transaction_no: value.transaction_no
  }
  return apiHelper().put(`${URL.PAYMENT}/${URL.STRIPE}/${URL.PAYMENT_INTENT}`, requestBody)
}

function downloadTest(URL) {
  return apiHelper().get(URL, { responseType: 'arraybuffer' })
}
